var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#1C1C1A",
  fillRule: "evenodd",
  d: "M3.896 15.854a.5.5 0 0 1 0-.708L11.043 8 3.896.854a.5.5 0 1 1 .708-.708L12.457 8l-7.853 7.854a.5.5 0 0 1-.708 0",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
export { SvgChevronRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzgxN185Nzc4KSI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMy44OTY0NSAxNS44NTM2QzMuNzAxMTggMTUuNjU4MyAzLjcwMTE4IDE1LjM0MTcgMy44OTY0NSAxNS4xNDY0TDExLjA0MjkgOEwzLjg5NjQ1IDAuODUzNTU0QzMuNzAxMTggMC42NTgyOTIgMy43MDExOCAwLjM0MTcwOSAzLjg5NjQ1IDAuMTQ2NDQ3QzQuMDkxNzEgLTAuMDQ4ODE0OCA0LjQwODI5IC0wLjA0ODgxNDggNC42MDM1NSAwLjE0NjQ0N0wxMi40NTcxIDhMNC42MDM1NSAxNS44NTM2QzQuNDA4MjkgMTYuMDQ4OCA0LjA5MTcxIDE2LjA0ODggMy44OTY0NSAxNS44NTM2WiIgZmlsbD0iIzFDMUMxQSIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzgxN185Nzc4Ij4KPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";